import React, { useState, useEffect } from 'react';
import './../../Styles/leadstyles/ConvertToLead.css';
import { useToast } from '../ToastContext';
const apiUrl = process.env.REACT_APP_API_URL;

const ConvertToLead = ({ managerId }) => {
  const showToast = useToast();
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState('');
  const [loading, setLoading] = useState(true);

  const effectiveManagerId = managerId || localStorage.getItem('employeeId') || '';

  // Function to fetch employees under manager
  const fetchEmployees = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/get-employees?managerId=${encodeURIComponent(effectiveManagerId)}`);
      const data = await response.json();
      setEmployees(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error fetching employees:', error);
      showToast('Failed to load employees.', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, [effectiveManagerId]);

  // Handle form submission to convert employee to lead
  const handleConvertToLead = async (e) => {
    e.preventDefault();

    if (!selectedEmployee) {
      showToast('Please select an employee.', 'error');
      return;
    }

    try {
      const response = await fetch(`${apiUrl}/api/convert-employee-to-lead`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ employeeNumber: selectedEmployee }),
      });

      const result = await response.json();
      if (response.ok) {
        showToast(`Employee ${selectedEmployee} converted to lead successfully.`, 'success');
        setSelectedEmployee('');
        fetchEmployees();
      } else {
        showToast(result.message || 'Failed to convert employee.', 'error');
      }
    } catch (error) {
      console.error('Error converting employee:', error);
      showToast('Failed to convert employee.', 'error');
    }
  };

  return (
    <div className="convert-to-lead-container">
      <h4>Convert Employee to Lead</h4>
      <select
        value={selectedEmployee}
        onChange={(e) => setSelectedEmployee(e.target.value)}
      >
        <option value="">Select an Employee</option>
        {employees.map((employee) => (
          <option key={employee.employee_number} value={employee.employee_number}>
            {employee.full_name} - {employee.job_title}
          </option>
        ))}
      </select>
      <button onClick={handleConvertToLead}>Convert to Lead</button>


      

    </div>
  );  
};

export default ConvertToLead;
